// components/skeletons/SubscriptionManagementSkeleton.jsx
import React from "react";
import Header from "../header/Header";
import Sidebar from "../sidebar/Sidebar";
import "./SubscriptionSkeleton.css";

const SubscriptionManagementSkeleton = () => {
  return (
    <div className="dashboard-layout">
      <Header />
      <Sidebar />
      <div className="dashboard-content subscription-management">

        {/* Title */}
        <div className="skel skel-title" />
        <div className="skel skel-subtitle" />

        {/* Subscription card */}
        <div className="skel-mg-card">

          {/* Card header */}
          <div className="skel-mg-card-header">
            <div className="skel-mg-plan-info">
              <div className="skel skel-mg-badge" />
              <div className="skel skel-mg-amount" />
            </div>
            <div className="skel skel-mg-status" />
          </div>

          {/* Detail rows */}
          <div className="skel-mg-details">
            {[1, 2, 3].map((i) => (
              <div key={i} className="skel-mg-detail-row">
                <div className="skel skel-mg-label" />
                <div className="skel skel-mg-value" />
              </div>
            ))}
          </div>

          {/* Cancel button area */}
          <div className="skel-mg-actions">
            <div className="skel skel-mg-cancel-btn" />
            <div className="skel skel-mg-note" />
            <div className="skel skel-mg-note short" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionManagementSkeleton;